export const ENDPOINTS = {
  CREATE_CONFIGURATION: '/project-configuration',
  EDIT_CONFIGURATION: (projectConfigurationId: string) => `/project-configuration/${projectConfigurationId}`,
  SEARCH_CONFIGURATIONS: '/project-configuration/search',
  GET_SERVICE: ({ serviceId, regionId }: { serviceId: string; regionId: string }) =>
    `/service/${serviceId}/price?regionCode=${regionId}`,
};
